import { render } from "./SiteBannerPreview.vue?vue&type=template&id=0c3800a4&scoped=true"
import script from "./SiteBannerPreview.vue?vue&type=script&lang=js"
export * from "./SiteBannerPreview.vue?vue&type=script&lang=js"

import "./SiteBannerPreview.vue?vue&type=style&index=0&id=0c3800a4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c3800a4"]])

export default __exports__